import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import Button from "../../../component-lib/Molecules/button/Button";
import useDeviceType from "../../../custom-hooks/DeviceType";

interface PatientProfileNotFoundProps {
  searchedValue: string;
  searchedType: string;
  getAddNewPatientButtonClickEvent: () => void;
}

const PatientProfileNotFound = ({
  searchedValue,
  searchedType,
  getAddNewPatientButtonClickEvent,
}: PatientProfileNotFoundProps) => {
  const deviceType = useDeviceType();

  const handleButtonClick = () => {
    getAddNewPatientButtonClickEvent();
  };

  return (
    <div className="w-full bg-neutral-10 flex flex-col items-center py-6 gap-4">
      <Heading
        title="No Result Found"
        customStyle={{ fontWeight: "500", color: "#565656" }}
      />
      {searchedType === "name" && (
        <p
          className={`text-neutral-50 text-sm font-normal text-center ${deviceType === "mobile" ? "px-3" : ""}`}
        >
          No participant found with the name{" "}
          <span className="text-neutral-70 text-sm font-medium">
            "{searchedValue}"
          </span>
          . Please verify the name and try again.
        </p>
      )}
      {searchedType === "bsa" && (
        <p
          className={`text-neutral-50 text-sm font-normal text-center ${deviceType === "mobile" ? "px-3" : ""}`}
        >
          No participant found with the BSA ID{" "}
          <span className="text-neutral-70 text-sm font-medium">
            "{searchedValue}"
          </span>
          . Please verify the ID and try again.
        </p>
      )}

      <Button
        label="Add New Patient"
        variant="outlined"
        onClickCb={() => {
          handleButtonClick();
        }}
        style={{
          padding: "10px 16px",
          border: "1px solid #005596",
          fontSize: "16px",
          fontWeight: "500",
          boxShadow: "none",
        }}
      ></Button>
    </div>
  );
};

export default PatientProfileNotFound;
